/**
 * @desc 采购审核
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryPurchaseExamineRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/purchaseExamine`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
